export const FLEXIBLE_PROJECT_VALUE_RANGE_VALUE = 'flexible';

export const PROJECT_VALUE_RANGE_SELECT_OPTIONS = [
  { label: 'Flexible', value: FLEXIBLE_PROJECT_VALUE_RANGE_VALUE },
  { label: 'Less than $100', value: '11' },
  { label: '$100 - $1000', value: '10' },
  { label: '$1,000 - $5,000', value: '9' },
  { label: '$5,000 - $10,000', value: '4' },
  { label: '$5,000 - $20,000', value: '12' },
  { label: '$20,000 - $100,000', value: '13' },
  { label: 'More than $100,000', value: '8' },
];

export function formatProjectValueRangeId(value?: number): string {
  return value ? value.toString() : FLEXIBLE_PROJECT_VALUE_RANGE_VALUE;
}

export function parseProjectValueRangeId(value?: string): number | undefined {
  if (!value || value === FLEXIBLE_PROJECT_VALUE_RANGE_VALUE) {
    return undefined;
  }

  const parsedValue = Number.parseInt(value, 10);
  return Number.isNaN(parsedValue) ? undefined : parsedValue;
}
